import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';

export const KeywordAssignmentFormTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		'features/RegDocs/keywordAssignmentForm',
	);
